import { useForm } from "react-hook-form";
import DialogComponent from "../../../../../components/dialog-component/dialog-component";
import TextInputFormField from "../../../../../components/form-fields/text-input-field/text-input-form-field";
import { AddNewClientModalProps, Client } from "./types";
import {
  ModalBaseForm,
  ModalButtonsContainer,
} from "../../../../../components/dialog-component/dialog-component.styles";
import { PrimaryButton } from "../../../../../components/button/button";
import { clientFormValidation } from "../../../../../utils/validations";
import { yupResolver } from "@hookform/resolvers/yup";
import PhoneNumberFormField from "../../../../../components/form-fields/phone-number-field/phone-number-form-field";
import { useAppDispatch } from "../../../../../store/hooks";
import { useState } from "react";
import { addClient } from "../../../../../actions";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { v4 as uuid } from "uuid";
import { Clients } from "../types";
import AsyncPaginateFormField from "../../../../../components/form-fields/asyncpaginate-field/async-paginate-field";
import { loadAddressOptions } from "../../../../../utils/common-utils";

const ModalBody: React.FC<AddNewClientModalProps> = ({
  onClose,
  setValue,
  setClients,
  handleClientChange,
}) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { control, handleSubmit } = useForm({
    mode: "all",
    resolver: yupResolver(clientFormValidation()),
  });

  const onSubmit = (formValues: any) => {
    const payload = { ...formValues, address: formValues?.address?.value };
    setIsLoading(true);
    addClient(payload)
      .then((response: any) => {
        const { message, data }: { message: string; data: Client } =
          response.data;
        onClose && onClose();
        setClients((clients: Clients) => [...clients, data]);
        setTimeout(() => {
          setValue("search", `${data.first_name} ${data.last_name}`.trim());
          handleClientChange(null, {
            id: data.integration_id,
            label: `${data.first_name} ${data.last_name}`.trim(),
          });
        }, 500);
        dispatch(
          addNotification({
            id: uuid(),
            type: "success",
            message: message,
          })
        );
      })
      .catch((error) => {
        dispatch(
          addNotification({
            id: uuid(),
            type: "error",
            message: error.response?.data?.message || error.message,
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <ModalBaseForm>
      <TextInputFormField
        name="firstName"
        control={control}
        label="First Name"
        placeholder="Enter here"
      />
      <TextInputFormField
        name="lastName"
        control={control}
        label="Last Name"
        placeholder="Enter here"
      />
      <TextInputFormField
        name="email"
        control={control}
        label="Email"
        placeholder="Enter here"
      />
      <PhoneNumberFormField
        name="mobile"
        label={"Phone Number"}
        control={control}
      />
      {/* <TextInputFormField
        name="address"
        control={control}
        label="Address"
        placeholder="Enter here"
      /> */}
      <AsyncPaginateFormField
        id="address"
        name="address"
        label="Address"
        control={control}
        loadOptions={loadAddressOptions}
        placeholder="Type your address..."
      />
      <TextInputFormField
        name="numberOfPets"
        control={control}
        label="Number of pets"
        placeholder="Enter here"
      />
      <ModalButtonsContainer onClick={handleSubmit(onSubmit)}>
        <PrimaryButton isLoading={isLoading}>Add client</PrimaryButton>
      </ModalButtonsContainer>
    </ModalBaseForm>
  );
};

const AddNewClientModal: React.FC<AddNewClientModalProps> = ({
  open,
  onClose,
  setValue,
  setClients,
  handleClientChange,
}) => {
  return (
    <DialogComponent
      title="Add client"
      content={
        <ModalBody
          handleClientChange={handleClientChange}
          setClients={setClients}
          setValue={setValue}
          onClose={onClose}
          open={open}
        />
      }
      open={open}
      onClose={onClose}
    />
  );
};

export default AddNewClientModal;
